import { handleResponse, handleError, headerset } from "../apiUtils";

// ============================================
// BASE URL
// ============================================

const baseUrl = () => {
    return process.env.API_URL + "/api/schedulazione/carico-reparti";
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch carico reparti panoramico (tutti i reparti, per il Gantt)
 * GET /api/schedulazione/carico-reparti/{data_da}/{giorni}/
 */
export function fetchCaricoReparti(dataDa: string, giorni: number) {
    const url = `${baseUrl()}/${dataDa}/${giorni}/`;

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Fetch carico reparto dettaglio con operatori
 * GET /api/schedulazione/carico-reparti/{data_da}/{giorni}/{reparto_id}/
 */
export function fetchCaricoReparto(dataDa: string, giorni: number, repartoId: number) {
    const url = `${baseUrl()}/${dataDa}/${giorni}/${repartoId}/`;

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}
